import dayjs from 'dayjs';

/** 1.234.567,89 — as the books print figures, whatever the UI language. */
export const money = (value) =>
  Number(value || 0).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/** Blank for zero, for the debit / credit columns of a line. */
export const moneyOrBlank = (value) => (Math.abs(Number(value) || 0) < 0.005 ? '' : money(value));

export const date = (value) => (value ? dayjs(value).format('DD.MM.YYYY') : '');

/** "735.643,06 P": the balance with its side in the reader's language; "0,00" when settled. */
export const balanceText = (block, t) =>
  block?.side ? `${money(Math.abs(block.balance))} ${t(`blocks.side${block.side}`)}` : money(0);

/** The address reads `a,b` back as a list; filters are plain strings. */
export const str = (value) => (Array.isArray(value) ? value.join(',') : value || '');

export const errorText = (t, error) => error?.response?.data?.message || error?.message || t('errors.load');

export const saveBlob = (blob, fileName) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

/**
 * The labels an export is printed with, in the user's language: the server
 * takes only these keys and falls back to Serbian / English for the rest.
 */
export const exportLabels = (t) => ({
  title: t('export.title'),
  company: t('export.company'),
  account: t('head.account'),
  partner: t('head.partner'),
  project: t('head.project'),
  period: t('head.period'),
  address: t('head.address'),
  pib: t('head.pib'),
  bankAccount: t('head.bankAccount'),
  opening: t('blocks.opening'),
  inPeriod: t('blocks.period'),
  total: t('blocks.total'),
  debit: t('blocks.debit'),
  credit: t('blocks.credit'),
  balance: t('blocks.balance'),
  sideD: t('blocks.sideD'),
  sideP: t('blocks.sideP'),
  orderDate: t('columns.orderDate'),
  orderNo: t('columns.orderNo'),
  orgUnit: t('columns.orgUnit'),
  description: t('columns.description'),
  invoiceNo: t('columns.invoiceNo'),
  contract: t('columns.contract'),
  entryDate: t('columns.entryDate'),
  documentDate: t('columns.documentDate'),
  dueDate: t('columns.dueDate'),
  vatChange: t('columns.vatChange'),
  operator: t('columns.operator'),
  currency: t('columns.currency'),
  debitFx: t('columns.debitFx'),
  creditFx: t('columns.creditFx'),
  // Kept with its placeholder: the server fills the count.
  truncated: t('export.truncated', { count: '{{count}}', interpolation: { skipOnVariables: true } }),
  unbookedTitle: t('unbooked.title'),
  unbookedHint: t('unbooked.hint'),
  unbookedDays: t('unbooked.days'),
  unbookedReason: t('unbooked.reason'),
  ...Object.fromEntries(
    ['missing', 'supplier', 'year', 'pending', 'notChecked'].map((r) => [`reason${r}`, t(`unbooked.reasons.${r}`)])
  ),
  unbookedTotal: t('unbooked.totalPlain'),
  expected: t('unbooked.expected'),
  bookBalance: t('unbooked.bookBalance'),
  unbookedNumber: t('unbooked.number'),
  unbookedDate: t('unbooked.date'),
  unbookedDue: t('unbooked.due'),
  unbookedGross: t('unbooked.gross'),
  unbookedCurrency: t('unbooked.currency'),
  unbookedStatus: t('unbooked.status'),
  unbookedSupplier: t('unbooked.supplier'),
  unbookedFxNote: t('unbooked.fxNote'),
  unbookedNone: t('unbooked.none'),
  unbookedNoPib: t('unbooked.noPib'),
  unbookedNoProject: t('unbooked.noProject'),
  unbookedNotTracked: t('unbooked.notTracked'),
  unbookedNoPartner: t('unbooked.noPartner'),
  unbookedTruncated: t('unbooked.truncated', { count: '{{count}}', interpolation: { skipOnVariables: true } }),
  ...Object.fromEntries(
    ['NEW', 'SEEN', 'RE_NOTIFIED', 'APPROVED', 'ENTERED', 'MANUAL_CONFIRMED'].map((key) => [
      `status${key}`,
      t(`unbooked.statuses.${key}`),
    ])
  ),
});
